export const NAME_KEY = 'FORM_NAME';
export const EMAIL_KEY = 'FORM_EMAIL';
export const BUSINESS_NAME_KEY = 'FORM_BUSINESS_NAME';